import {CLStore} from 'common/src/redux/store';
import initializeBrandGuidelinesAgents from './initializeBrandGuidelinesAgents';
import initializeBrandGuidelinesUiContexts from './initializeBrandGuidelinesUiContexts';

function initializeBrandGuidelines(store: CLStore) {
  initializeBrandGuidelinesUiContexts(store);
  initializeBrandGuidelinesAgents(store);
}

export default initializeBrandGuidelines;
